import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'

import styles from './widgets.module.sass'
import { renderContacts } from './utils'

const InsurancePolicyWidget = (props) => {
	const { data } = props
	const { process } = data
	const { i18n } = useGlobal()

	return (
		<ExpandableWidget
			className={styles['aside-widget']}
			titleAppearance='aside-widget'
			arrowPosition='right'
			heading='h5'
			icon='reports'
			title={i18n`Insurance Policy`}
			collapsedLabel={process?.insurancePolicy?.policyNumber}
			expanded={false}
			expandable={!!process?.insurancePolicy}
			borderRadius
			margins={['small', '', '']}
			paddings={['xsmall', 'xsmall', 'xsmall']}
		>
			<HStack
				className={styles['entry']}
				columns={[1, 3]}
				gap='xsmall'
				justify='space-between'
			>
				<small>
					<strong>{i18n`Insured`}</strong>
				</small>
				<small>{process?.insurancePolicy?.insured?.name}</small>
			</HStack>
			{process?.accident?.segment?.abbreviation === 'AD' ? (
				<HStack
					className={styles['entry']}
					columns={[1, 3]}
					gap='xsmall'
					justify='space-between'
				>
					<small>
						<strong>{i18n`Club`}</strong>
					</small>
					<small>
						{process?.insurancePolicy?.AdDetails?.club ||
							process?.club?.name ||
							i18n`Not defined`}
					</small>
				</HStack>
			) : null}
			<HStack
				className={styles['entry']}
				columns={[1, 3]}
				gap='xsmall'
				justify='space-between'
			>
				<small>
					<strong>{i18n`Insurance Company`}</strong>
				</small>
				<small>
					{process?.insurancePolicy?.insuranceCompany?.shortName}
				</small>
			</HStack>
			<HStack
				className={styles['entry']}
				columns={[1, 3]}
				gap='xsmall'
				justify='space-between'
			>
				<small>
					<strong>{i18n`Policy Number`}</strong>
				</small>
				<small>{process?.insurancePolicy?.policyNumber}</small>
			</HStack>
			<HStack
				className={styles['entry']}
				columns={[1, 3]}
				gap='xsmall'
				justify='space-between'
			>
				<small>
					<strong>{i18n`External ID`}</strong>
				</small>
				<small>{process?.insurancePolicy?.externalId}</small>
			</HStack>
			{process?.accident?.segment?.abbreviation === 'AD' ? (
				<>
					<h5
						className={styles['group-title']}
					>{i18n`Policy Conditions`}</h5>
					<HStack
						className={styles['entry']}
						columns={[1, 3]}
						gap='xsmall'
						justify='space-between'
					>
						<small>
							<strong>{i18n`Plafond`}</strong>
						</small>
						<small>
							{process?.insurancePolicy?.AdDetails
								?.policyConditions?.plafond
								? `
										${process?.insurancePolicy?.AdDetails?.policyConditions.plafond} €
									`
								: i18n`Not defined`}
						</small>
					</HStack>
					<HStack
						className={styles['entry']}
						columns={[1, 3]}
						gap='xsmall'
						justify='space-between'
					>
						<small>
							<strong>{i18n`Franchise`}</strong>
						</small>
						<small>
							{process?.insurancePolicy?.AdDetails
								?.policyConditions?.franchise
								? `
								${process?.insurancePolicy?.AdDetails?.policyConditions.franchise} €
							`
								: i18n`Not defined`}
						</small>
					</HStack>
				</>
			) : null}
			{process?.injured?.contacts ? (
				<h5
					className={styles['group-title']}
				>{i18n`Injured Contacts`}</h5>
			) : null}
			{renderContacts(process?.injured?.contacts || {}, i18n)}
		</ExpandableWidget>
	)
}

export default InsurancePolicyWidget
